/**
 * theme.js — Fan Merch Shopify Theme
 * All client-side behavior in a single file.
 */

(function () {
  'use strict';

  /* ==========================================================
     HEADER — scroll behavior, inverse on home
     ========================================================== */
  const header = document.querySelector('.header');
  if (header) {
    const isHome = header.classList.contains('header--home');

    // Scroll handler — toggle .header--scrolled
    function onScroll() {
      if (!isHome) return;
      if (window.scrollY > 20) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ==========================================================
     SMOOTH SCROLL — data-scroll-to buttons
     ========================================================== */
  document.querySelectorAll('[data-scroll-to]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.querySelector(btn.getAttribute('data-scroll-to'));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });


  /* ==========================================================
     LQIP — lazy load real images with blur-up transition
     ========================================================== */
  var lqipImages = document.querySelectorAll('img.lqip');
  if (lqipImages.length > 0 && 'IntersectionObserver' in window) {
    var lqipObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var img = entry.target;
        lqipObserver.unobserve(img);

        var fullImg = new Image();
        fullImg.srcset = img.dataset.srcset || '';
        fullImg.sizes = img.sizes || '';
        fullImg.src = img.dataset.src || '';

        fullImg.onload = function () {
          img.srcset = fullImg.srcset;
          img.src = fullImg.src;
          img.classList.add('lqip-loaded');
          img.addEventListener('transitionend', function handler() {
            img.classList.remove('lqip', 'lqip-loaded');
            img.removeEventListener('transitionend', handler);
          });
        };
      });
    }, { rootMargin: '200px' });

    lqipImages.forEach(function (img) { lqipObserver.observe(img); });
  } else {
    // Fallback: load all immediately
    lqipImages.forEach(function (img) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.classList.remove('lqip');
    });
  }

  /* ==========================================================
     CART BADGE — pop animation on count change
     ========================================================== */
  const cartBadge = document.querySelector('.header__cart-badge');
  let lastCount = cartBadge ? parseInt(cartBadge.textContent, 10) : 0;

  function popBadge() {
    if (!cartBadge) return;
    cartBadge.classList.add('header__cart-badge--pop');
    setTimeout(function () {
      cartBadge.classList.remove('header__cart-badge--pop');
    }, 300);
  }

  function updateCartBadge(count) {
    if (!cartBadge) return;
    const currentCount = parseInt(cartBadge.textContent, 10);
    if (count !== currentCount) {
      cartBadge.textContent = count;
      if (count > 0) {
        cartBadge.style.display = 'flex';
        popBadge();
      } else {
        cartBadge.style.display = 'none';
      }
    }
  }

  /* ==========================================================
     SHOPIFY CART API HELPERS
     ========================================================== */
  async function cartFetch(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    return res.json();
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    });
    return res.json();
  }

  async function refreshCartBadge() {
    const cart = await getCart();
    updateCartBadge(cart.item_count);
    return cart;
  }

  /* ==========================================================
     BACK TO SHOP — use browser history when possible
     ========================================================== */
  var backLink = document.querySelector('[data-back-link]');
  if (backLink) {
    backLink.addEventListener('click', function (e) {
      // If the user came from the home page, go back to restore scroll position
      if (document.referrer && new URL(document.referrer).origin === location.origin) {
        e.preventDefault();
        history.back();
      }
      // Otherwise fall through to the normal href="/" link
    });
  }

  /* ==========================================================
     PRODUCT PAGE — variant selection, thumbnails, add to cart
     ========================================================== */
  const productForm = document.querySelector('.product-form');
  if (productForm) {
    const variantDataEl = document.getElementById('product-variant-data');
    const variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
    const priceEl = document.querySelector('.product-detail__price');
    const mainImg = document.querySelector('.product-detail__main-img');
    const variantIdInput = productForm.querySelector('input[name="id"]');
    const addBtn = productForm.querySelector('.product-detail__add-btn');
    const addBtnText = addBtn ? addBtn.querySelector('.add-btn-text') : null;
    const thumbs = document.querySelectorAll('.product-detail__thumb');

    // Track selected options
    const selectedOptions = {};
    const optionButtons = productForm.querySelectorAll('.product-detail__option-btn, .product-detail__color-swatch');

    // Initialize selected options from default buttons
    optionButtons.forEach(function (btn) {
      if (btn.classList.contains('product-detail__option-btn--selected') ||
          btn.classList.contains('product-detail__color-swatch--selected')) {
        selectedOptions[btn.dataset.optionName] = btn.dataset.optionValue;
      }
    });

    // Filter thumbnails by color — show only matching + untagged images
    var thumbsContainer = document.querySelector('.product-detail__thumbnails');

    function filterThumbnails(color) {
      if (!color) {
        thumbs.forEach(function (t) { t.style.display = ''; });
        updateThumbsVisibility();
        return;
      }
      var colorLower = color.toLowerCase();
      var visibleCount = 0;
      thumbs.forEach(function (t) {
        var imgColor = (t.dataset.color || '').toLowerCase();
        var show = !imgColor || imgColor === colorLower;
        t.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      });
      // If no images match this color, show all
      if (visibleCount === 0) {
        thumbs.forEach(function (t) { t.style.display = ''; });
      }
      updateThumbsVisibility();
    }

    function updateThumbsVisibility() {
      if (thumbsContainer) {
        var visible = Array.from(thumbs).filter(function (t) { return t.style.display !== 'none'; });
        thumbsContainer.style.display = visible.length <= 1 ? 'none' : '';
      }
      updateDots();
    }

    // Set main image with LQIP blur-up
    function setMainImage(src) {
      if (!mainImg || !src) return;
      var matchingThumb = thumbMap[src];
      var srcset = matchingThumb ? matchingThumb.dataset.srcset : '';
      var lqip = matchingThumb ? matchingThumb.dataset.lqip : '';

      // If we have a tiny placeholder, show it blurred immediately
      if (lqip && mainImg.src !== src) {
        mainImg.srcset = '';
        mainImg.src = lqip;
        mainImg.classList.add('lqip');

        // Load full image in background
        var full = new Image();
        full.srcset = srcset || '';
        full.sizes = '(max-width: 768px) 100vw, 50vw';
        full.src = src;
        full.onload = function () {
          mainImg.srcset = full.srcset;
          mainImg.sizes = full.sizes;
          mainImg.src = src;
          mainImg.classList.add('lqip-loaded');
          mainImg.addEventListener('transitionend', function handler() {
            mainImg.classList.remove('lqip', 'lqip-loaded');
            mainImg.removeEventListener('transitionend', handler);
          });
        };
      } else {
        mainImg.srcset = srcset || '';
        mainImg.sizes = '(max-width: 768px) 100vw, 50vw';
        mainImg.src = src;
      }

      thumbs.forEach(function (t) {
        t.classList.toggle('product-detail__thumb--active', t.dataset.fullSrc === src);
      });
      updateDots();
    }

    // Build thumb lookup map for fast access
    var thumbMap = {};
    thumbs.forEach(function (t) {
      thumbMap[t.dataset.fullSrc] = t;
    });

    // Detect which option name is "color" (case-insensitive)
    var colorOptionName = null;
    optionButtons.forEach(function (btn) {
      var name = btn.dataset.optionName || '';
      if (/^colou?r$/i.test(name)) colorOptionName = name;
    });

    // Mark non-color option buttons (e.g. sizes) as disabled when no available
    // variant exists for that value given the current selection.
    function updateOptionAvailability() {
      optionButtons.forEach(function (btn) {
        var name = btn.dataset.optionName;
        if (name === colorOptionName) return;
        var probe = Object.assign({}, selectedOptions);
        probe[name] = btn.dataset.optionValue;
        var match = variants.find(function (v) {
          return v.options.every(function (opt) {
            return probe[opt.name] === opt.value;
          });
        });
        btn.disabled = !(match && match.available);
      });
    }

    // Option click handler
    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.dataset.optionName;
        var value = btn.dataset.optionValue;
        selectedOptions[name] = value;

        // Update selected value label
        var selectedLabel = document.querySelector('[data-option-selected="' + name + '"]');
        if (selectedLabel) selectedLabel.textContent = value;

        // Update button states for this option group
        var siblings = productForm.querySelectorAll(
          '[data-option-name="' + name + '"]'
        );
        siblings.forEach(function (s) {
          var isMatch = s.dataset.optionValue === value;
          if (s.classList.contains('product-detail__color-swatch')) {
            s.classList.toggle('product-detail__color-swatch--selected', isMatch);
          } else {
            s.classList.toggle('product-detail__option-btn--selected', isMatch);
          }
        });

        // Refresh availability of non-color options for the new selection
        updateOptionAvailability();

        // Find matching variant
        var variant = variants.find(function (v) {
          return v.options.every(function (opt) {
            return selectedOptions[opt.name] === opt.value;
          });
        });

        if (variant) {
          variantIdInput.value = variant.id;
          if (priceEl) priceEl.textContent = variant.priceFormatted;
          if (variant.image) setMainImage(variant.image);
          if (addBtn) {
            addBtn.disabled = !variant.available;
            if (addBtnText) {
              addBtnText.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
            }
          }
        }

        // Filter thumbnails when color changes
        if (name === colorOptionName) {
          filterThumbnails(value);
          // If variant has no specific image, show first visible thumb's image
          if (!variant || !variant.image) {
            var firstVisible = Array.from(thumbs).find(function (t) {
              return t.style.display !== 'none';
            });
            if (firstVisible) setMainImage(firstVisible.dataset.fullSrc);
          }
        }
      });
    });

    // Initial availability pass — disables sizes unavailable for the default color.
    updateOptionAvailability();

    // Initial filter based on default color selection + show matching image
    if (colorOptionName && selectedOptions[colorOptionName]) {
      filterThumbnails(selectedOptions[colorOptionName]);
      // Find the current variant and show its image, or fallback to first visible thumb
      var initVariant = variants.find(function (v) {
        return v.options.every(function (opt) {
          return selectedOptions[opt.name] === opt.value;
        });
      });
      if (initVariant && initVariant.image) {
        setMainImage(initVariant.image);
      } else {
        var firstVisible = Array.from(thumbs).find(function (t) {
          return t.style.display !== 'none';
        });
        if (firstVisible) setMainImage(firstVisible.dataset.fullSrc);
      }
    }

    // Preload cache — avoid duplicate fetches
    var preloaded = {};
    function preloadImage(src, srcset) {
      if (!src || preloaded[src]) return;
      preloaded[src] = true;
      var img = new Image();
      if (srcset) { img.srcset = srcset; img.sizes = '(max-width: 768px) 100vw, 50vw'; }
      img.src = src;
    }

    // Thumbnail hover — preload full image
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('mouseenter', function () {
        preloadImage(thumb.dataset.fullSrc, thumb.dataset.srcset);
      });
      thumb.addEventListener('touchstart', function () {
        preloadImage(thumb.dataset.fullSrc, thumb.dataset.srcset);
      }, { passive: true });
    });

    // Color swatch hover — preload the variant's image (or first matching thumb)
    optionButtons.forEach(function (btn) {
      if (!btn.classList.contains('product-detail__color-swatch')) return;
      function preloadVariantImage() {
        var color = btn.dataset.optionValue;
        var testOptions = Object.assign({}, selectedOptions);
        testOptions[btn.dataset.optionName] = color;
        var variant = variants.find(function (v) {
          return v.options.every(function (opt) {
            return testOptions[opt.name] === opt.value;
          });
        });
        if (variant && variant.image) {
          var thumb = thumbMap[variant.image];
          preloadImage(variant.image, thumb ? thumb.dataset.srcset : '');
        } else {
          // Fallback: preload first thumbnail that matches this color
          var colorLower = color.toLowerCase();
          var match = Array.from(thumbs).find(function (t) {
            var imgColor = (t.dataset.color || '').toLowerCase();
            return !imgColor || imgColor === colorLower;
          });
          if (match) preloadImage(match.dataset.fullSrc, match.dataset.srcset);
        }
      }
      btn.addEventListener('mouseenter', preloadVariantImage);
      btn.addEventListener('touchstart', preloadVariantImage, { passive: true });
    });

    // Thumbnail click
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMainImage(thumb.dataset.fullSrc);
      });
    });

    // Dots indicator + swipe navigation (mobile)
    var dotsContainer = document.getElementById('product-image-dots');
    var mainImageWrap = document.querySelector('.product-detail__main-image');

    function getVisibleThumbs() {
      return Array.from(thumbs).filter(function (t) { return t.style.display !== 'none'; });
    }

    function getCurrentIndex() {
      var visible = getVisibleThumbs();
      var currentSrc = mainImg ? mainImg.src : '';
      for (var i = 0; i < visible.length; i++) {
        if (currentSrc.indexOf(visible[i].dataset.fullSrc) !== -1 ||
            visible[i].classList.contains('product-detail__thumb--active')) {
          return i;
        }
      }
      return 0;
    }

    function updateDots() {
      if (!dotsContainer) return;
      var visible = getVisibleThumbs();
      if (visible.length <= 1) {
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = '';
      var idx = getCurrentIndex();
      var html = '';
      for (var i = 0; i < visible.length; i++) {
        html += '<button class="product-detail__dot' + (i === idx ? ' product-detail__dot--active' : '') + '" data-dot-index="' + i + '" type="button" aria-label="Image ' + (i + 1) + '"></button>';
      }
      dotsContainer.innerHTML = html;
    }

    // Dot click
    if (dotsContainer) {
      dotsContainer.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-dot-index]');
        if (!dot) return;
        var visible = getVisibleThumbs();
        var idx = parseInt(dot.dataset.dotIndex, 10);
        if (visible[idx]) setMainImage(visible[idx].dataset.fullSrc);
      });
    }

    // Swipe on main image
    if (mainImageWrap) {
      var touchStartX = 0;
      var touchStartY = 0;
      var swiping = false;

      mainImageWrap.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        swiping = true;
      }, { passive: true });

      mainImageWrap.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        // Only register horizontal swipes (not vertical scrolls)
        if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;

        var visible = getVisibleThumbs();
        if (visible.length <= 1) return;
        var idx = getCurrentIndex();
        if (dx < 0 && idx < visible.length - 1) {
          setMainImage(visible[idx + 1].dataset.fullSrc);
        } else if (dx > 0 && idx > 0) {
          setMainImage(visible[idx - 1].dataset.fullSrc);
        }
      }, { passive: true });
    }

    // Initial dots
    updateDots();

    // AJAX add to cart
    productForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (addBtn) addBtn.disabled = true;
      if (addBtnText) addBtnText.textContent = 'Adding...';

      try {
        await cartFetch('/cart/add.js', {
          id: parseInt(variantIdInput.value, 10),
          quantity: 1
        });
        await refreshCartBadge();
      } catch (err) {
        console.error('Add to cart failed:', err);
      } finally {
        if (addBtn) addBtn.disabled = false;
        if (addBtnText) addBtnText.textContent = 'Add to Cart';
      }
    });
  }

  /* ==========================================================
     BASE PRODUCT DATA — fetch JSON for products with a base code
     ========================================================== */
  var baseProductData = null;
  var sizeChartDialog = document.getElementById('size-chart-modal');

  (function initBaseProduct() {
    var infoEl = document.querySelector('[data-base-code]');
    if (!infoEl || !window.__baseProductsUrl) return;

    var baseCode = infoEl.dataset.baseCode;
    var baseUrl = window.__baseProductsUrl;

    fetch(baseUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var bp = data[baseCode];
        if (!bp) return;
        baseProductData = bp;
        initSizeChart(bp, baseUrl);
        renderComposition(bp);
      })
      .catch(function (err) {
        console.error('Base product fetch failed:', err);
      });
  })();

  /* ==========================================================
     SIZE CHART MODAL
     ========================================================== */
  function initSizeChart(bp, baseUrl) {
    if (!sizeChartDialog) return;

    // Schematic
    var schematicEl = document.getElementById('size-chart-schematic');
    if (schematicEl && bp.schematicImage) {
      var img = document.createElement('img');
      img.src = baseUrl.replace('base-products.json', bp.schematicImage);
      img.alt = bp.name + ' size schematic';
      img.className = 'size-chart-modal__schematic-img';
      schematicEl.appendChild(img);
    }

    // Build initial table
    var unit = localStorage.getItem('size-chart-unit') || 'cm';
    buildSizeTable(bp.sizeChart, unit);
    setActiveUnit(unit);

    // Unit toggle
    var toggleWrap = document.getElementById('size-chart-toggle');
    if (toggleWrap) {
      toggleWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-unit]');
        if (!btn) return;
        var newUnit = btn.dataset.unit;
        localStorage.setItem('size-chart-unit', newUnit);
        buildSizeTable(bp.sizeChart, newUnit);
        setActiveUnit(newUnit);
      });
    }
  }

  function buildSizeTable(chart, unit) {
    var wrap = document.getElementById('size-chart-table-wrap');
    if (!wrap || !chart) return;

    var isInch = unit === 'in';
    var fmt = function (v) {
      if (isInch) return (v * 0.3937).toFixed(1);
      return v % 1 === 0 ? String(v) : v.toFixed(1);
    };

    var rows = [
      { label: 'A \u2014 Half Chest', data: chart.halfChest },
      { label: 'B \u2014 Body Length', data: chart.bodyLength },
      { label: 'C \u2014 Sleeve Length', data: chart.sleeveLength }
    ];

    var html = '<table class="size-chart-modal__table">';
    html += '<thead><tr><th>' + unit.toUpperCase() + '</th>';
    for (var i = 0; i < chart.sizes.length; i++) html += '<th>' + chart.sizes[i] + '</th>';
    html += '</tr></thead><tbody>';
    for (var r = 0; r < rows.length; r++) {
      html += '<tr><td>' + rows[r].label + '</td>';
      for (var c = 0; c < rows[r].data.length; c++) html += '<td>' + fmt(rows[r].data[c]) + '</td>';
      html += '</tr>';
    }
    html += '</tbody></table>';
    wrap.innerHTML = html;
  }

  function setActiveUnit(unit) {
    var btns = document.querySelectorAll('#size-chart-toggle [data-unit]');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].dataset.unit === unit) {
        btns[i].classList.add('size-chart-modal__unit--active');
      } else {
        btns[i].classList.remove('size-chart-modal__unit--active');
      }
    }
  }

  /* ==========================================================
     COMPOSITION ACCORDION
     ========================================================== */
  function renderComposition(bp) {
    var accordion = document.getElementById('accordion-composition');
    var body = document.getElementById('accordion-composition-body');
    if (!accordion || !body) return;

    var specs = [
      { label: 'Shell', value: bp.shell },
      { label: 'Weight', value: bp.gsm + ' GSM' },
      { label: 'Composition', value: bp.composition },
      { label: 'Processing', value: bp.processing }
    ];

    if (bp.compositionAlt) {
      specs.splice(3, 0, { label: 'Alternate', value: bp.compositionAlt });
    }

    var html = '';
    for (var i = 0; i < specs.length; i++) {
      html += '<div class="product-detail__spec"><dt>' + specs[i].label + '</dt><dd>' + specs[i].value + '</dd></div>';
    }

    body.innerHTML = html;
    accordion.hidden = false;
  }


  // Open modal
  var sizeGuideTrigger = document.getElementById('size-guide-trigger');
  if (sizeGuideTrigger && sizeChartDialog) {
    sizeGuideTrigger.addEventListener('click', function () {
      sizeChartDialog.showModal();
    });
  }

  // Close modal — close button, backdrop click (Escape handled natively by <dialog>)
  if (sizeChartDialog) {
    sizeChartDialog.querySelector('.size-chart-modal__close').addEventListener('click', function () {
      sizeChartDialog.close();
    });
    sizeChartDialog.addEventListener('click', function (e) {
      if (e.target === sizeChartDialog) sizeChartDialog.close();
    });
  }

  /* ==========================================================
     CART PAGE — quantity updates, remove items
     ========================================================== */
  const giftToggle = document.querySelector('[data-cart-gift-toggle]');
  if (giftToggle) {
    giftToggle.addEventListener('change', async function () {
      giftToggle.disabled = true;
      try {
        await cartFetch('/cart/update.js', {
          attributes: { Gift: giftToggle.checked ? 'Yes' : '' }
        });
      } catch (err) {
        console.error('Gift attribute update failed:', err);
        giftToggle.checked = !giftToggle.checked;
      } finally {
        giftToggle.disabled = false;
      }
    });
  }

  const cartItems = document.querySelector('.cart-items');
  if (cartItems) {
    cartItems.addEventListener('click', async function (e) {
      const btn = e.target.closest('[data-cart-action]');
      if (!btn) return;

      const lineItem = btn.closest('.cart-line-item');
      if (lineItem) lineItem.classList.add('cart-line-item--updating');

      const action = btn.dataset.cartAction;
      const lineKey = btn.dataset.lineKey;
      const currentQty = parseInt(btn.dataset.currentQty || '1', 10);

      try {
        if (action === 'remove') {
          await cartFetch('/cart/change.js', { id: lineKey, quantity: 0 });
        } else if (action === 'decrease') {
          await cartFetch('/cart/change.js', { id: lineKey, quantity: Math.max(0, currentQty - 1) });
        } else if (action === 'increase') {
          await cartFetch('/cart/change.js', { id: lineKey, quantity: currentQty + 1 });
        }
        // Reload page to reflect changes
        window.location.reload();
      } catch (err) {
        console.error('Cart update failed:', err);
        if (lineItem) lineItem.classList.remove('cart-line-item--updating');
      }
    });
  }

})();
